module.exports = __webpack_public_path__ + "static/img/圆角矩形1.48400dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Economics/圆角矩形1.png
// module id = +YrO
// module chunks = 0